export const ServerName = import.meta.env.VITE_BACKEND; //"http://localhost:8045"; //import.meta.env.VITE_BACKEND || ""; //"http://localhost:8045";
export const BaseUrl = import.meta.env.VITE_ROUTER_BASE || "/";
import.meta.env.VITE_BACKEND || "";
export const AIEndPoint = import.meta.env.VITE_AI_BACKEND;
export const AIPremiumEndpoint = import.meta.env.VITE_AI_PREMIUM_SERVER;
export const AIPremiumEndpoint2 = import.meta.env.VITE_AI_PREMIUM_2_SERVER;
export const AIStandardEndpoint = import.meta.env.VITE_AI_STANDARD_BACKEND;
export const ReportEndpoint = import.meta.env.VITE_REPORT_BACKEND || ServerName;
